import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  NAV_MENU_TERMS,
  NAV_MENU_TERMS_AFTER,
  NAV_MENU_TERMS_BEFORE,
} from '@shopgate/engage/core';
import {
  Portal,
  NavDrawer,
  DescriptionIcon,
} from '@shopgate/engage/components';
import { TERMS_PATH } from '@shopgate/engage/page/constants';
import portalProps from '../../../../portalProps';
import connect from '../../../../connector';

const LABEL = 'navigation.terms';

/**
 * @param {Object} props The component props
 * @param {Function} props.navigate The navigate props
 * @returns {JSX.Element}
 */
const TermsButton = ({ navigate }) => (
  <>
    <Portal name={NAV_MENU_TERMS_BEFORE} props={portalProps} />
    <Portal name={NAV_MENU_TERMS} props={portalProps}>
      <NavDrawer.Item
        label={LABEL}
        icon={DescriptionIcon}
        onClick={navigate(TERMS_PATH, LABEL)}
        testId="navDrawerTermsButton"
      />
    </Portal>
    <Portal name={NAV_MENU_TERMS_AFTER} props={portalProps} />
  </>
);

TermsButton.propTypes = {
  navigate: PropTypes.func.isRequired,
};

export default connect(TermsButton);
